<template>
    <div class="w-full flex justify-center">
        <nav v-if="breadcrumbList.length > 1" aria-label="breadcrumb" class="flex items-center text-xs text-ihh-midnight-gray font-ihh-bold ml-2 mt-8 mb-4 max-w-4xl">
            <router-link v-for="(crumb, index) in breadcrumbList" :key="index" :to="crumb.path" class="hover:text-ihh-midnight-gray">
                <span v-html="crumb.name"></span>
                <span v-if="index < breadcrumbList.length - 1" class="mx-2">&gt;</span>
            </router-link>
        </nav>
    </div>
</template>

<script>
export default {
    data() {
        return {
            breadcrumbs: [],
        }
    },
    computed: {
        breadcrumbList() {
            return this.breadcrumbs;
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.updateBreadcrumbs();
            },
        },
    },
    methods: {
        updateBreadcrumbs() {
            const breadcrumbs = [{ name: 'Home', path: '/' }];
            let currentRoute = this.$route;

            // Traverse the route matched array to build the breadcrumb
            currentRoute.matched.forEach(route => {
                if (route.meta && route.meta.breadcrumb) {
                    breadcrumbs.push({
                        name: route.meta.breadcrumb,
                        path: route.path
                    });
                }
            });

           // Custom logic for /account/addresses/:id and /account/addresses/create
           if (currentRoute.path.includes('/account/addresses/')) {
                breadcrumbs.splice(breadcrumbs.length - 1, 0, {
                    name: 'Address Book',
                    path: '/account/addresses'
                });
            }

            if (currentRoute.path.includes('/account/lists/')) {
                breadcrumbs.splice(breadcrumbs.length - 1, 0, {
                    name: 'Your Wishlists',
                    path: '/account/lists'
                });
            }

            if (currentRoute.path.includes('/account/orders/')) {
                breadcrumbs.splice(breadcrumbs.length - 1, 0, {
                    name: 'Your Orders',
                    path: '/account/orders'
                });
            }


            this.breadcrumbs = breadcrumbs;
        },
    },
}
</script>
